import { combineReducers } from 'redux';
import aesReduxConstants from '../constants';
import mapPinReducer from './mapPinReducer';

export var mapQuickSearchReducer = function() {
  const constants = aesReduxConstants.MAP.QUICK_SEARCH;

  const loadingReducer = function(state, action) {
    const defaultState = false;

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.QUICK_SEARCH:
        return true;
      case constants.QUICK_SEARCH_ERROR:
      case constants.QUICK_SEARCH_SUCCESS:
        return false;
      default:
        return state;
    }
  };

  const resultsReducer = function(state, action) {
    const defaultState = {
      clientLocations: {
        results: [],
        message: '',
      },
      mapLocations: {
        results: [],
        message: '',
      },
    };

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.QUICK_SEARCH_SUCCESS:
        return action.results;
      default:
        return state;
    }
  };

  const queryReducer = function(state, action) {
    const defaultState = '';

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.QUICK_SEARCH:
      case constants.QUICK_SEARCH_SET_QUERY:
        return action.query;
      default:
        return state;
    }
  };

  return combineReducers({
    results: resultsReducer,
    isLoading: loadingReducer,
    query: queryReducer,

    // create the pin reducer by giving a prefix
    pin: mapPinReducer(constants.PREFIX),
  });
};

export default mapQuickSearchReducer();
